import {Fill} from '#lit/components/base/icon/index.js';

import {html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import styles from './style.scss';
import {property} from 'lit-element';
import {ExpressionTypes} from '#lit/types/builders/audience_builder/index.js';

export const FILTER_TYPE_ICON_ELEMENT_TAG = 'ab-filter-type-icon';

/**
 * FilterTypeIcon -- Description here
 */
@customElement(FILTER_TYPE_ICON_ELEMENT_TAG)
export default class FilterTypeIcon extends FlywheelComponent {
  @property()
  type: ExpressionTypes = ExpressionTypes.STRING;

  static get styles() {
    return [styles];
  }

  get icon(): string {
    switch (this.type) {
      case ExpressionTypes.STRING: {
        return '/assets/string_expression_icon.svg';
      }

      case ExpressionTypes.INT:
      case ExpressionTypes.NUMBER:
      case ExpressionTypes.NUMERIC:
      case ExpressionTypes.INT_64:
      case ExpressionTypes.FLOAT:
      case ExpressionTypes.FLOAT_64:
      case ExpressionTypes.INTEGER:
      case ExpressionTypes.INTEGER_64: {
        return '/assets/number_expression_icon.svg';
      }

      case ExpressionTypes.DATE:
      case ExpressionTypes.DATETIME:
      case ExpressionTypes.TIMESTAMP: {
        return '/assets/datetime_expression_icon.svg';
      }

      case ExpressionTypes.BOOL:
      case ExpressionTypes.BOOLEAN: {
        return '/assets/boolean_expression_icon.svg';
      }

      case ExpressionTypes.ARRAY:
      case ExpressionTypes.ARRAY_STRING:
      case ExpressionTypes.ARRAY_BOOL:
      case ExpressionTypes.ARRAY_BOOLEAN:
      case ExpressionTypes.ARRAY_NUMBER:
      case ExpressionTypes.ARRAY_INT:
      case ExpressionTypes.ARRAY_INT_64:
      case ExpressionTypes.ARRAY_INTEGER:
      case ExpressionTypes.ARRAY_INTEGER_64:
      case ExpressionTypes.ARRAY_FLOAT:
      case ExpressionTypes.ARRAY_FLOAT_64:
      case ExpressionTypes.ARRAY_NUMERIC:
      case ExpressionTypes.ARRAY_DATE:
      case ExpressionTypes.ARRAY_DATETIME:
      case ExpressionTypes.ARRAY_TIMESTAMP: {
        return '/assets/array_expression_icon.svg';
      }

      case ExpressionTypes.REALTIME: {
        return 'bolt';
      }
    }
  }

  get isSVG(): boolean {
    return this.type != ExpressionTypes.REALTIME;
  }

  get fill(): Fill {
    return this.isSVG ? Fill.BASE : Fill.WHITE_DARK;
  }

  render() {
    return html`
      <div class="filter-type-icon">
        <fly-icon
          ?svg=${this.isSVG}
          icon=${this.icon}
          fill=${this.fill}
        ></fly-icon>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [FILTER_TYPE_ICON_ELEMENT_TAG]: FilterTypeIcon;
  }
}
